<template>
  <div>
    <ExcelImport @onDataImported="onDataImported" />
    <PreviewList ref="preview-student-dialog" @onSave="onSave" />
  </div>
</template>
<script>
import ExcelImport from './ExcelImport.vue'
import PreviewList from './PreviewList.vue'

export default {
  components: { ExcelImport, PreviewList },
  methods: {
    onDataImported(data) {
      this.$refs['preview-student-dialog'].openDialog(data)
    },
    onSave() {
      this.$emit('onSave')
    }
  }
}
</script>
